<template>
  <section class="container-fluid p-0 bodyArea">
    <div class="justify-content-start">
      <div class="pageHeader row justify-content-between">
        <div>Activities</div>


      </div>

      <div v-if="$auth.isAuthenticated" class="d-flex align-items-center  my-3 mr-3">
        <div class="d-flex align-items-center compactFilterWrapper" style="width: 400px">
          <div class="filterText">Tenant :</div>
          <model-select style="background: transparent; color: #fff; border: 0; height: auto"
            v-model="lastSelectedTenant" :options="tenants" name="tenantDropdown" id="tenantDropdownId"
            placeholder="Select Tenant" class="dropdownList" @input="queryDataBasedOnTenantSelection">
          </model-select>
        </div>

        <div class="d-flex align-items-center compactFilterWrapper" style="width: 400px">
          <div class="filterText">Connections :</div>
          <model-select style="background: transparent; color: #fff; border: 0; height: auto"
            v-model="lastSelectedConnection" :options="sanitizedGroups" name="connectionDropdown" id="connectionDropdownId" value-field="value" text-field="text"
            placeholder="Select Connection" class="dropdownList" @input="queryDataBasedOnConnection">
          </model-select>
        </div>
      </div>
      <hr />
    </div>

    <div class="mx-3 my-3 d-flex align-items-center">
      <p class="my-2" style="font-size: 18px">Filters:</p>
      <div class="mr-3 d-flex align-items-center justify-content-start">
        <div class="d-flex align-items-center ml-3">
          <p class="m-0 ">First Name</p>
          <div v-if="$auth.isAuthenticated" class="subFilterWrapper">
            <input type="text" class="formatDateTime mr-2" v-model="firstName" />
          </div>
        </div>

        <div class="d-flex align-items-center">
          <p class="m-0 ml-3">Last Name</p>
          <div v-if="$auth.isAuthenticated" class="subFilterWrapper">
            <input type="text" class="formatDateTime mr-2" v-model="lastName" />
          </div>
        </div>

        <div class="d-flex align-items-center">
          <p class="m-0 ml-3">Email</p>
          <div v-if="$auth.isAuthenticated" class="subFilterWrapper">
            <input type="text" class="formatDateTime mr-2" v-model="email" />
          </div>
        </div>
      </div>


      <div class="d-flex justify-content-end align-items-end">
        <button id="filterSubmitBtn" :disabled="disableFilter()" class="filterWrapper submitBtn"
          @click="fetchFilteredSessions">
          Submit
        </button>
        <button id="filterSubmitBtn" class="filterWrapper submitBtn" @click="resetFilters">
          Reset
        </button>
      </div>
    </div>

    <div class="mx-3 my-3">
      <ul class="nav">
        <li class="nav-item" @click="doAction('users')" :class="{ active: action === 'users' }">
          <a class="nav-link" aria-current="page" href="javascript:void(0);">Users</a>
        </li>
        <li class="nav-item" @click="doAction('logs')" :class="{ active: action === 'logs' }">
          <a class="nav-link" aria-current="page" href="javascript:void(0);">Logs</a>
        </li>
      </ul>
      <div v-if="action === 'users'" class="grid-container">
        <div class="grid-item left">
          <p class="">Auth Connection Users</p>
          <div v-if="authUsers.length > 0">
            <div v-for="(item, index) in authUsers" :key="index" class="grid-item-content">
              <pre v-text="JSON.stringify(item, null, 2)"></pre>
            </div>
          </div>
          <div v-if="authUsers.length === 0">
            No result Found
          </div>
        </div>
        <div class="grid-item right">
          <p class="">IDA Users</p>
          <pre v-if="idaUsers" v-text="JSON.stringify(idaUsers, null, 2)"></pre>
        </div>
      </div>
      <div v-if="action === 'logs'" class="log-container">
        <div class="row m-0 align-items-center">
          <div class="col-6 pad0">
            <b-card class="card-container-panel" v-if="userLogs.auth0_logs && userLogs.auth0_logs.logs && userLogs.auth0_logs.logs.length > 0">
              <p>Auth0 Logs</p>
              <div class="contentHeader row m-0 align-items-center">
                <div class="col-3">Data</div>
                <div>Activity</div>
              </div>
              <div style="height: 550px;overflow-y: auto;">
                <div v-for="(item, index) in userLogs.auth0_logs.logs">
                  <div class="contentDataWrapper actions contentActualDataWrapper row m-0" :class="{'row-light': index % 2}">
                    <div class="contentData row m-0 align-items-center col-12 p-0">
                      <div class="col-3">{{item.data_formatted}}</div>
                      <div>{{item.type_description}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </b-card>
          </div>
          <div class="col-6 pad0">
            <b-card class="card-container-panel" v-if="userLogs.service_audit_logs && userLogs.service_audit_logs.logs && userLogs.service_audit_logs.logs.length > 0">
              <p>IDA Audit logs</p>
              <div class="contentHeader row m-0 align-items-center">
                <div class="col-3">Data</div>
                <div>Activity</div>
              </div>
              <div style="height: 550px;overflow-y: auto;">
                <div v-for="(item, index) in userLogs.service_audit_logs.logs">
                  <div class="contentDataWrapper actions contentActualDataWrapper row m-0" :class="{'row-light': index % 2}">
                    <div class="contentData row m-0 align-items-center col-12 p-0">
                      <div class="col-3">{{item.receiveTimestamp_formatted}}</div>
                      <div>{{item.module_id}} - {{item.service_path_formatted}} - {{item.audit_message}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </b-card>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="mx-3 my-3 d-flex">
      <div class="leftNav">
        <div class="accordion">
          <p class="">Auth Connection Users</p>


        </div>
      </div>
      <div class="rightNav">
        <div class="accordion">
          <p class="">IDA Users</p>

          <div v-if="idaUsers.length > 0">
            <div v-for="(item, index) in idaUsers" :key="index" class="accordion-item">
              <button class="accordion-header" @click="toggleRight(index)">
                {{ item.name.first + ' ' + item.name.last }}
                <span>{{ activeIndexRight === index ? '-' : '+' }}</span>
              </button>
              <div v-show="activeIndexRight === index" class="accordion-content">
                <p>{{ formattedJson(item) }}</p>
              </div>
            </div>

          </div>
          <div v-if="idaUsers.length === 0">
            <div class="accordion-item">
              <button class="accordion-header">
                No result Found
              </button>
            </div>
          </div>
        </div>

      </div>
    </div> -->

  </section>
</template>

<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import Dropdown from "vue-simple-search-dropdown";
import { ModelSelect } from "vue-search-select";
import { keyBy } from "lodash";
import moment from 'moment';
import Datepicker from "vue2-datepicker";
import auth0Types from "../assets/auth-log-types.json";

Vue.use(VueToast);
Vue.filter('dateFormat', function (value, format = 'MM/DD/YYYY hh:mm:ss A') {
  // Ensure value is not null or undefined
  if (!value) return '';

  // Format the date using moment.js
  return moment(value).format(format);
});

export default {
  name: "Activities",
  components: { Dropdown, ModelSelect, Datepicker },
  computed: {
  sanitizedGroups() {
    return this.groups.map(item => ({
      ...item,
      text: item.text.replace(/-/g, '–') 
    }));
  }
},
  data() {
    return {
      format: "MM-DD-YYYY",
      showModal: false,
      firstName: "",
      lastName: "",
      email: "",
      tenantsList: [],
      groups: [],
      tenants: [{ text: "", value: "" }],
      lastSelectedTenant: "",
      lastSelectedConnection: "",
      activeIndex: null,
      activeIndexRight: null,
      idaUsers: null,
      authUsers: [],
      action: "users",
      userId: "",
      userLogs: {},
      auth0Types
    };
  },

  async created() {
    setTimeout(
      function () {
        this.fetchTenants();
      }.bind(this),
      1000
    );
  },
  methods: {
    toggle(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
    toggleRight(index) {
      this.activeIndexRight = this.activeIndexRight === index ? null : index;
    },
    doAction(action) {
      this.action = action
    },
    disableFilter() {
      if (this.lastSelectedTenant !== '' && this.lastSelectedConnection !== '' && (this.firstName.trim().length > 0 || this.lastName.trim().length > 0 || this.email.trim().length > 0))
        return false;
      else
        return true
    },
    async fetchTenants() {
      if (!this.$auth.isAuthenticated) {
        return;
      }
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var tenants_list_request = new Request(config.TENET_SERVICE + "/tenants/?list=true", {
        method: "GET",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var tenantListResponse = await fetch(tenants_list_request);
        if (tenantListResponse.status === 403) {
          Vue.$toast.open({
            message: "Uh oh... You don't have the permission required to access this resource",
            type: "error"
          });
          return;
        }
        if (tenantListResponse.status == 401) {
          Vue.$toast.open({
            message: "Your session has expired please login again to continue",
            type: "error"
          });
          return;
        }
        if (tenantListResponse.status == 503) {
          return this.fetchTenants();
        }
        if (tenantListResponse.status != 200) {
          Vue.$toast.open({
            message: "Unable to get data",
            type: "error"
          });
          return;
        } else {
          var tenantsBody = await tenantListResponse.json();
          this.tenants = tenantsBody.map((t) => {
            return {
              text: t.text || t.value,
              value: t.value
            };
          });
          this.tenants = this.tenants.sort(function (a, b) {
            var nameA = a.text.toUpperCase(); // ignore upper and lowercase
            var nameB = b.text.toUpperCase(); // ignore upper and lowercase

            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          });

          this.tenants.forEach((e) =>
            this.tenantsList.push({ id: e.value, name: e.text || e.value })
          );
        }
      } catch (tex) {
        Vue.$toast.open({ message: "Failed to get tenant list due to an error.", type: "error" });
      }
    },
    async queryDataBasedOnTenantSelection() {
      await this.getGroups();
    },
    async getGroups() {
      this.groups = [];
      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots",
      });
      this.listEmpty = false;
      // this.groups = [];
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.OPERATIONS_SERVICE +
        `/tenants/${this.lastSelectedTenant}/auth0-connection`;
      var saml_Groups = new Request(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var response = await fetch(saml_Groups);
        if (response.status === 503) {
          return this.getGroups();
        }
        if (response.status === 403) {
          console.log("response", response)
          Vue.$toast.open({
            message: "Access Denied",
            type: "error",
          });
          loader.hide();
          return true;
        }
        var groups_saml = await response.json();
        this.groups = groups_saml.map((t) => {
          return {
            text: t.name,
            value: t.name
          };
        });
        console.log("this.groups", this.groups)
        this.groups = this.groups.sort(function (a, b) {
          var nameA = a.text.toUpperCase(); // ignore upper and lowercase
          var nameB = b.text.toUpperCase(); // ignore upper and lowercase

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
        loader.hide();
      } catch (error) {
        console.error(error);
        loader.hide();
      }
    },
    async queryDataBasedOnConnection() {

    },
    async getAuth0Users() {
      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots",
      });
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      let urlString = this.firstName.trim().length > 0 ? this.firstName : this.lastName.trim().length > 0 ? this.lastName : this.email;
      var url = config.OPERATIONS_SERVICE + `/users/auth/serach-user`;
      var auth_users_req = new Request(url, {
        method: "POST",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        body: JSON.stringify({
          "connectionName": this.lastSelectedConnection,
          "name": urlString
        }),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var response = await fetch(auth_users_req);
        if (response.status === 503) {
          return this.getAuth0Users();
        }
        if (response.status === 403) {
          console.log("response", response)
          Vue.$toast.open({
            message: "Access Denied",
            type: "error",
          });
          loader.hide();
          return true;
        }
        var usersObj = await response.json();
        if (usersObj && usersObj.data && usersObj.data.length > 0) {
          this.authUsers = usersObj.data;
          if (this.authUsers[0].email) {
            this.email = this.authUsers[0].email;
          }
          this.userId = this.authUsers[0].user_id;
        }
        else {
          this.authUsers = [];
          this.idaUsers = null;
          Vue.$toast.open({
            message: "Could not find user based on the search params provided for Auth0",
            type: "error",
          });
        }

        loader.hide();
      } catch (error) {
        console.error(error);
        loader.hide();
      }
    },
    async getIDAUsers(emailId) {
      if (!emailId) {
        Vue.$toast.open({
          message: "Please enter email address of the user to search",
          type: "error",
        });
        return;
      }

      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots",
      });
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      let urlString = this.firstName.trim().length > 0 ? this.firstName : this.lastName.trim().length > 0 ? this.lastName : this.email;
      var url =
        config.OPERATIONS_SERVICE + `/tenants/${this.lastSelectedTenant}/identities/${emailId}`;
      var ida_users_req = new Request(url, {
        method: "POST",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var response = await fetch(ida_users_req);
        if (response.status === 503) {
          return this.getIDAUsers(emailId);
        }
        if (response.status === 403) {
          console.log("response", response)
          Vue.$toast.open({
            message: "Access Denied",
            type: "error",
          });
          loader.hide();
          return true;
        }
        if (response.status === 404) {
          this.idaUsers = { message: "resource not found" }
          loader.hide();
          return true;
        }
        this.idaUsers = await response.json();
        loader.hide();
      } catch (error) {
        console.error(error);
        loader.hide();
      }
    },
    async getUserLogs(userId, email) {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      let urlString = this.firstName.trim().length > 0 ? this.firstName : this.lastName.trim().length > 0 ? this.lastName : this.email;
      var url = config.OPERATIONS_SERVICE + `/users/${userId}/audit-logs?email=${email}`;
      var user_audit_logs_request = new Request(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0'
        },
      });
      try {
        var response = await fetch(user_audit_logs_request);
        if (response.status === 503) {
          return this.getIDAUsers(emailId);
        }
        if (response.status === 403) {
          console.log("response", response)
          Vue.$toast.open({
            message: "Access Denied",
            type: "error",
          });
          loader.hide();
          return true;
        }
        if (response.status === 404) {
          this.idaUsers = { message: "resource not found" }
          loader.hide();
          return true;
        }
        const userLogs = await response.json();
        if (userLogs && userLogs.auth0_logs && userLogs.auth0_logs.logs && userLogs.auth0_logs.logs.length > 0) {
          userLogs.auth0_logs.logs.forEach(log => {
            if (log.date) {
              log["data_formatted"] = new Date(log.date).toLocaleString();
            }
            if (log.type) {
              const authType = this.auth0Types.find(a => a.event_code === log.type);
              if (authType) {
                log["type_description"] = log.description || authType.event_description || authType.event;
              }
            }
          })
        }
        if (userLogs && userLogs.service_audit_logs && userLogs.service_audit_logs.logs && userLogs.service_audit_logs.logs.length > 0) {
          userLogs.service_audit_logs.logs.forEach((log) => {
            if (log.message) {
              const auditLogContent = this.extractBrackets(log.message);
              if (auditLogContent.length > 0) {
                log["message_user"] = auditLogContent[2];
                log["service_path"] = auditLogContent[3];
                log["audit_message"] = this.getTextAfterLastBracket(log.message, "]");
                log["service_path_formatted"] = this.getTextAfterLastPath(auditLogContent[3], "/");
              }
            }
            if (log.receiveTimestamp && log.receiveTimestamp.value) {
              log["receiveTimestamp_formatted"] = new Date(log.receiveTimestamp.value).toLocaleString();
            }
          })
        }
        this.userLogs = userLogs;
        console.log("userAuditLogs", JSON.stringify(this.userLogs));
        loader.hide();
      } catch (error) {
        console.error(error);
        loader.hide();
      }
    },
    extractBrackets(str) {
      // Match anything inside square brackets []
      const matches = str.match(/\[(.*?)\]/g) || [];

      // Remove the brackets themselves
      return matches.map(m => m.slice(1, -1));
    },
    getTextAfterLastBracket(str, lastChar) {
      const lastIndex = str.lastIndexOf(lastChar);
      return lastIndex !== -1 ? str.slice(lastIndex + 1).trim() : "";
    },
    getTextAfterLastPath(str, lastChar) {
      const lastIndex = str.lastIndexOf(lastChar);
      return lastIndex !== -1 ? str.slice(lastIndex).trim() : "";
    },
    async fetchFilteredSessions() {
      this.userLogs = {};
      this.authUsers = [];
      this.idaUsers = null;

      let loader = Vue.$loading.show({
        color: "skyblue",
        opacity: 0.1,
        loader: "dots"
      });
      await this.getAuth0Users();
      await this.getIDAUsers(this.email);
      this.getUserLogs(this.userId, this.email);
      loader.hide();
    },
    resetFilters() {
      this.firstName = "";
      this.lastName = "";
      this.email = "";
    },
    formattedJson(jsonObject) {
      return JSON.stringify(jsonObject, null, 2); // Pretty print JSON
    }
  }
};
</script>
<style lang="scss">
body .dropdown .dropdown-input {
  border: none !important;
  padding: 0 15px !important;
  background: none !important;
  font-size: 16px !important;
}

body .dropdown.dropdownList .dropdown-input {
  color: #fff !important;
  border: none !important;
  padding: 0 15px !important;
  background: none !important;
  font-size: 14px !important;
}

body .dropdown .dropdown-input:focus,
body .dropdown .dropdown-input:focus-visible {
  outline: none;
}

.dropdownList input::-webkit-input-placeholder,
input.filterInputText::-webkit-input-placeholder,
input.search::-webkit-input-placeholder {
  color: #fff !important;
}

::-webkit-scrollbar {
  width: 5px;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #d7d7d7 !important;
  border-radius: 10px;
}

::-webkit-scrollbar-track {
  background: #fafafa !important;
}
</style>

<style lang="scss" scoped>
@font-face {
  font-family: GTWalsheimPro-Regular;
  src: url(../assets/fonts/GTWalsheimPro-Regular.eot);
  src: url(../assets/fonts/GTWalsheimPro-Regular.eot) format('embedded-opentype'),
    url(../assets/fonts/GTWalsheimPro-Regular.ttf) format('truetype'),
    url(../assets/fonts/GTWalsheimPro-Regular.svg) format('svg');
  font-weight: normal;
  font-style: normal;
}

*,
:after,
:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

body,
html {
  font-family: GTWalsheimPro-Regular !important;
  background: #fff !important;
  font-size: 16px;
  overflow-x: hidden;
}

b,
strong {
  font-weight: 500;
}

button,
html input[type='button'],
input[type='reset'],
input[type='submit'] {
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled],
html input[disabled] {
  cursor: not-allowed !important;
  opacity: 0.65;
  filter: alpha(opacity=65);
  -webkit-box-shadow: none;
  box-shadow: none;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
  outline: 0 !important;
}

a,
a img,
a:active,
a:focus,
button:focus,
a:hover {
  outline: 0 !important;
  -webkit-transition: all 0.35s;
  -moz-transition: all 0.35s;
  transition: all 0.35s;
  text-decoration: none;
  cursor: pointer;
  color: #5ed1d1;
}

a:hover {
  text-decoration: underline;
}

img {
  border: 0 !important;
}

a:focus:not(:hover),
button:focus:not(:hover) {
  outline: 0;
}

::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: rgba(4, 78, 89, 1) !important;
}

::-moz-placeholder {
  /* Firefox 19+ */
  color: rgba(4, 78, 89, 1) !important;
}

:-ms-input-placeholder {
  /* IE 10+ */
  color: rgba(4, 78, 89, 1) !important;
}

:-moz-placeholder {
  /* Firefox 18- */
  color: rgba(4, 78, 89, 1) !important;
}

::-moz-selection {
  /* Code for Firefox */
  color: #fbeeef;
  background: #202533;
}

::selection {
  color: #fbeeef;
  background: #202533;
}

/* Scroll Bar Styling */

/* width */
::-webkit-scrollbar {
  width: 5px;
  border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f2fdff;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #a6e3f0;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #a6e3f0;
  border-radius: 10px;
}

/* Checkbox CSS ends here */
.bodyArea {
  font-family: GTWalsheimPro-Regular;
}

.pageHeader {
  height: 56px;
  color: #fff;
  background: #484848;
  font-size: 15px;
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
}

.pageHeader .filterText {
  padding-right: 0px !important;
}

.pageHeader .filterText.pad-10 {
  padding-right: 10px !important;
}

.dropDownContainer {
  background: #575757;
  display: inline-flex;
  padding: 0px 15px;
  font-size: 15px;
  border-radius: 5px;
  // margin-left: 15px;
  line-height: 36px;
  text-overflow: ellipsis;
  height: 38px;
}


.subFilterWrapper {
  background: #fff;
  display: inline-flex;
  padding: 0;
  font-size: 15px;
  min-width: 250px;
  border-radius: 5px;
  margin-left: 15px;
  line-height: 34px;
  text-overflow: ellipsis;
  border: 1px solid #ebebeb;
}

.compactFilterWrapper {
  background: #fff;
  display: inline-flex;
  padding: 0px;
  font-size: 15px;
  border-radius: 5px;
  margin-left: 15px;
  line-height: 36px;
  min-width: 250px;
  text-overflow: ellipsis;
  border: 1px solid #ebebeb;
  height: 38px;
}

.filterWrapper.submitBtn {
  max-width: none !important;
  min-width: 0 !important;
  border: none;
  color: #fff;
  background: #1dd8f6;
}

.pageHeader .filterWrapper.submitBtn {
  background: #575757;
}

.pageHeader .filterWrapper.submitBtn:hover {
  background: #1dd8f6;
}

.filterWrapper.submitBtn:hover {
  background: #3188D2;
}

.filterText {
  color: #575757;
  opacity: 1;
  white-space: nowrap;
  padding-left: 10px;
}

.filterWrapper .dropdown {
  cursor: pointer;
  background: transparent !important;
  position: relative;
}

.filterWrapper .dropdown:before {
  content: '';
  border: solid #fff;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 2.5px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  position: absolute;
  right: 10px;
  top: 15px;
}

.filterWrapper.exportBtn {
  max-width: none !important;
  min-width: 0 !important;
  border: none;
  color: #fff;
}

.filterWrapper select {
  width: 100%;
  text-align: left;
  border: none;
}

.filterWrapper select.active {
  color: #6a6a6a;
}

.tableWrapper {
  font-size: 14px;
  margin: auto;
  width: 97%;
  overflow: auto;
  border-radius: 10px;
  border: 1px solid lightgray;
  border-top: 0;
}

body select {
  width: 100px !important;
  overflow: hidden !important;
  white-space: nowrap;
  text-overflow: ellipsis;
}

body select option {
  width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #6a6a6a;
}

body select[data-v-33144d13] {
  width: 200px !important;
  overflow: hidden !important;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.loader {
  border: 2px solid #f3f3f3;
  /* Light grey */
  border-top: 2px solid #484848;
  /* Blue */
  border-radius: 50%;
  width: 25px;
  height: 25px;
  animation: spin 1.5s linear infinite;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.formatDateTime {
  color: #6a6a6a;
  border: 0;
  background-color: transparent;
  text-align: left;
  outline: none;
  margin-left: 10px;
  width: 100%;
}

input[type='time']::-webkit-calendar-picker-indicator {
  // filter: invert(100%);
  cursor: pointer;
}

input[type='date']::-webkit-calendar-picker-indicator {
  // filter: invert(100%);
  cursor: pointer;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

::v-deep .ui.search.dropdown .text {
  max-width: 190px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  height: 15px;
  color: #fff;

}

.pageHeader ::v-deep .ui.search.dropdown .text {
  color: #fff;
}

.compactFilterWrapper ::v-deep .ui.search.dropdown .text {
  color: #6a6a6a;
}

.filterWrapper {
  line-height: 38px;
}

::v-deep .ui.dropdown .menu .item {
  max-width: 230px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

}

::v-deep .ui.selection.dropdown .menu {
  margin-top: 2px;
}

::v-deep .compactFilterWrapper .ui.dropdown .menu .item {
  max-width: 250px;
}

::v-deep .ui.active.search.dropdown input.search:focus+.text {
  color: #fff;
}

.filterInputText {
  max-width: 215px !important;
  background: #1dd8f6 !important;
  outline: none !important;
  border: 1px solid #1dd8f6 !important;
  color: #fff !important;
  padding: 4px 15px !important;
  border-radius: 5px;
  line-height: 38px !important;
}

.text-truncate {
  max-width: 85%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap !important;
}

::v-deep .table thead th {
  vertical-align: middle;
}

.modal-xl.session {
  max-width: 1367px;
}

::v-deep .ui.selection.dropdown .menu .item {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  // max-width: 334px;
  margin: 0px 10px 2px;
  padding: 10px 7px !important;
  border-radius: 5px;
  border: none;
}

.pageHeader ::v-deep .ui.default.dropdown:not(.button)>input:focus~.text,
.pageHeader ::v-deep .ui.dropdown:not(.button)>input:focus~.default.text,
.pageHeader ::v-deep .ui.active.search.dropdown input.search:focus+.text {
  color: #fff !important;
}

::v-deep .ui.selection.active.dropdown .menu {
  border: 1px solid #EBEBEB;
  box-shadow: 0 2px 3px 0 rgba(34, 36, 38, .15);
  padding: 10px 0;
  margin-top: 1px;
  border-top-width: 1px !important;
}

::v-deep.b-form-btn-label-control.form-control>.btn {
  background: none !important;
}

::v-deep .ui.selection.active.dropdown:hover,
::v-deep .ui.selection.active.dropdown {
  box-shadow: none;
}

::v-deep .ui.dropdown .menu>.item:hover {
  color: #1dd8f6;
  background: #EAF9FF !important;
}

::v-deep .ui.dropdown .menu>.item.selected {
  color: #1dd8f6;
  background: #fff;
}

.compactFilterWrapper .dropdown:before {
  content: "";
  border: solid #8e8e8e;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  position: absolute;
  right: 15px;
  top: 13px;
}

::v-deep .subFilterWrapper .btn {
  background: none !important;
}

::v-deep .subFilterWrapper .btn :hover {
  color: #1dd8f6 !important;

}

::v-deep .subFilterWrapper .btn :active {
  color: #1dd8f6 !important;

}

.subFilterWrapper .b-calendar .b-calendar-nav .btn :active {
  color: #1dd8f6 !important;
}

::v-deep.subFilterWrapper .btn-primary:not(:disabled):not(.disabled).active {
  color: #1dd8f6 !important;
}

.leftNav,
.rightNav {
  display: flex;
  width: 50%;
}


.accordion {
  width: 100%;
  // max-width: 400px;
  margin: 10px;
}

.accordion-item {
  border-bottom: 1px solid #ddd;
}

.accordion-header {
  width: 100%;
  padding: 10px;
  background: #f8f8f8;
  border: none;
  text-align: left;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}

.accordion-content {
  padding: 10px;
  background: #fff;
}

.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  /* Each takes 50% */
  width: 100vw;
  height: 100vh;
}

.grid-item {
  // min-width: 300px;
  
  padding: 10px;
  box-sizing: border-box;
  &.left {
    max-width: 60vw;
    min-width: 60vw;
  }
  &.right {
    max-width: 40vw;
    min-width: 40vw;
  }
}

.grid-item-content {
  // border-right: 1px solid #ddd;
}

// .left {
//   background-color: lightgreen;
// }

// .right {
//   background-color: lightpink;
// }
.log-container{
  display: list-item;
  grid-template-columns: 1fr 1fr;
  /* Each takes 50% */
  width: 100vw;
  height: 100vh;
}
.log-item{
  padding:10px;
  border-bottom: 1px solid #ddd;
}

.nav {
  display: flex;
  gap: .33em;

  .nav-item {
    margin: 0;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    padding-bottom: .3em;
    background: transparent;
    border-top: 1px solid #f3f3f3;
    border-right: 1px solid #f3f3f3;
    border-left: 1px solid #f3f3f3;
    transition: all ease-in-out 300ms;

    a.nav-link {
      padding: 0.25rem 1rem;
      color: #484848;
      font-size: 15px;
      font-weight: 400;
    }

    &:hover {
      background: #f3f3f3;
    }
  }

  .active {
    background: #00b5da;

    a.nav-link {
      color: white;
    }

    &:hover {
      background: #1dd8f6;
    }
  }

  .row-light {
    background-color: #f2f2f2;
    border-top: #2e2e2e 1px solid;
    border-bottom: #2e2e2e 1px solid;
  }

  .grid-fixed-height-scroll {
    height: 200px;
    overflow: auto;
  }
}
</style>
